module.exports = new __parcel__URL__("dark-mode.5b7c09da.svg").toString();